export default {
    key: 'employee-skipass',
    type: 'Activity',
    isUsingProductConfigPresets: false,
    hideCrossSells: false,
    disablePassengers: false,
    isLoadingPassengerOffers: true,
    isRental: false,
    activityId: '9a8034fd-7e86-4787-856e-d6846e45d40a',
    categoryId: undefined,
    defaultDuration: undefined,
    isMultiDay: false,
    isUsingProductPresets: false,
    isUsingReductionCards: false,
    isUsingKeyCards: true,
    isUsingPromos: true,
    isPromotionRequired: true,
    hidePassengerMeasurements: true,
    showDuration: false,
    upsells: [],
    salesTimeLimit: undefined,
    isUpsellDatesRestricted: false,
    maxNumberOfPeople: undefined,
    maxNumberOfPeopleGroupTariff: undefined,
    isUsingSeasonDates: true,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: '9a8034fd-7e86-4787-856e-d6846e45d40a',
    contentfulId: 'ma-saisonpass',
    steps: [],
} satisfies ProductConfigActivity;
